import { createTimeline, scrambleText, stagger } from 'https://esm.sh/animejs';

const tl = createTimeline({ loop: true });

tl.add('.slide:nth-child(1)', {
  opacity: {to: 1, duration: 250, ease: 'linear' },
  scale: [{from: .75, to: 1, duration: 2500, ease: 'inOut(3.5)'}],
  ease: 'inOut(3)',
});
tl.add('.slide:nth-child(1) p.center', {
  //scale: { from: 3 },
  color: { from: '#FFFFFF', to: '#FFFFFF' },
  innerHTML: scrambleText({
    override: ' ',
    ease: 'inQuad',
    duration: 500,
    from: 'center',
    cursor: '░▒▓█',
  }),
}, '<<');
tl.add('body', {
  background: 'var(--red-5)',
}, '<<+=50');
tl.add('.slide:nth-child(1) p:not(.center)', {
  scale: { from: .75 },
  color: { from: '#44D62C', to: 'rgba(68, 214, 44, 0.1)' },
  innerHTML: scrambleText({
    override: ' ',
    from: 'center',
    duration: 500,
    revealDelay: 250,
    cursor: '░▒▓',
    perturbation: .25,
  }),
}, stagger([250, 750], /*{ grid: true, from: 'center', ease: 'out(3)', start: '<<' }*/));
tl.add('.slide:nth-child(1) p:not(.center)', {
  innerHTML: scrambleText({
    text: '',
    override: false,
    from: 'center',
    ease: 'outQuad',
    reversed: true,
    duration: 800,
    cursor: '░▒▓',
  })
}, '<+=150');
tl.add('.slide:nth-child(1) p.center', {
  textShadow: '0 0 5px #44d62c',
}, '<-=600');
tl.add('.slide:nth-child(1) p.center', {
    scale: [{ to: 1.5, duration: 1500 }],
  //scale: 1.5,
  color: { to: '#44D62C', duration: 250 },
  ease: 'inOutExpo',
  //duration: 7500,
  innerHTML: scrambleText({
    text: 'OUR 24 HOUR GIVEAWAY',
    ease: 'inQuad',
    override: false,
    from: 'center',
    duration: 1000,
    perturbation: .25,
  }),
}, '<<');

tl.add('.slide:nth-child(1) p.center', {
  scale: 1,
  color: '#44D62C',
  ease: 'inOutExpo',
  duration: 2150,
  innerHTML: scrambleText({
    override: false,
    text: 'ENR#91',
    from: 'right',
    duration: 950,
    settleDuration: 500,
    ease: 'inOut'
  }),
}, '+=17500'); // was 17500
tl.add('.slide:nth-child(1) p.center', {
  scale: 1,
  color: '#44D62C',
  ease: 'inOutExpo',
  duration: 3150,
  innerHTML: scrambleText({
    override: false,
    text: '// 1440 MINUTES TO GET ENTERED',
    from: 'right',
    duration: 2950,
    settleDuration: 500,
    ease: 'inOut'
  }),
}, '<+=4000');
tl.add('.slide:nth-child(1) p.center', {
  innerHTML: scrambleText({
    override: false,
    text: 'ENRFORCE',
    from: 'right',
    duration: 2950,
    settleDuration: 500,
    ease: 'inOut'
  }),
}, '<+=1000');
tl.set('.slide:nth-child(1)', {
  opacity: {to: 0, duration: 500, ease: 'inOutExpo' },
}, '<+=500');
tl.set('.slide:nth-child(2)', {
  opacity: {to: 1, duration: 350, ease: 'inOutExpo' },
}, '<<');
tl.add('.slide:nth-child(2) img', {
  scale: [{from: .95, to: 1, duration: 500, ease: 'inOut(3.5)'}],
  ease: 'inOutExpo',
  duration: 500,
}, '<<');
tl.add('.slide:nth-child(2) img', {
  scale: 1,
  ease: 'inOutExpo',
  duration: 6000,
}, '<<');

tl.init();
